
import React from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { ComboBox } from 'office-ui-fabric-react/lib/ComboBox';

const classNames = mergeStyleSets({
    root: {
    }
});

function correspondOpsubToFilter(opsubItem, filter) {
    let correspond = true;
    filter.split(' ').forEach(item => {
        correspond = correspond && (
            (opsubItem._name.toUpperCase().indexOf(item) !== -1) ||
            (opsubItem._address.toUpperCase().indexOf(item) !== -1) ||
            ((opsubItem.rodne_cislo || '').indexOf(item) === 0) ||
            ((opsubItem.ico || '').indexOf(item) === 0)
        );
    });
    return correspond;
}

function createInfoOption(text) {
    return {
        text: text,
        disabled: true,
        key: '_'
    };
}

function getOptionsFunc(searchText, opsubItems) {
    let options = [];
    if (searchText.length > 1) {
        if (opsubItems.length > 0) {
            let count = Math.min(opsubItems.length, 10);
            let items = [];
            for (let i = 0; i < count; i++) {
                items.push(opsubItems[i]);
            }
            if (count < opsubItems.length) {
                options.push(createInfoOption(`(zobrazuje se pouze prvních 10 z ${opsubItems.length} vyhledaných vlastníků)`));
            }
            items.forEach(opsubItem => {
                let text = opsubItem._name;
                if (opsubItem.rodne_cislo) {
                    text = text + `, rč: ${opsubItem.rodne_cislo}`;
                }
                if (opsubItem.ico) {
                    text = text + `, IČO: ${opsubItem.ico}`;
                }
                text = text + `, ${opsubItem._address}`;

                options.push({
                    key: opsubItem.id,
                    text: text,
                    opsub: opsubItem
                });

            });

        } else {
            options.push(createInfoOption(`Nebyl nalezen žádný vlastník`));
        }
    } else {
        options.push(createInfoOption(`Zadejte alespoň 2 písmena pro vyhledání vlastníka`));
    }
    return options;
}

const SelectOpsubComboBox = ({opsubItem, opsubItems, onChange}) => {

    const [text, setText] = React.useState('');
    const [autoOpen, setAutoOpen] = React.useState(true);
    const [filteredOpsubItems, setFilteredOpsubItems] = React.useState([]);
    const ref = React.useRef(null);

    React.useEffect(() => {
        if (ref && ref.current) {
            if ((text && text.length > 0) && autoOpen) {
                ref.current.focus(true);
            }
        }

        if (text && text.length > 1) {
            const searchText = text.toUpperCase();
            setFilteredOpsubItems(
                opsubItems.filter(item => {
                    return correspondOpsubToFilter(item, searchText);
                })
            );
        } else {
            setFilteredOpsubItems([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [text]);

    const getOptions = () => {
        let options = getOptionsFunc(text, filteredOpsubItems);
        return options;
    }

    const handleChangeItem = (event, option, index, value) => {
        if (option) {
            onChange(option.opsub);
            if (option.opsub) {
                setText(option.text);
                setAutoOpen(false);
            } else {
                setText('');
            }
        }
    }

    const handlePendingValueChanged = (option, index, value) => {
        if (value) {
            setText(value);
            setAutoOpen(true);
        }
    }

    return (
        <div className={classNames.root}>
            <ComboBox
                allowFreeform={true}
                autoComplete="off"
                componentRef={ref}
                label="Vyhledat vlastníka"
                options={getOptions()}
                selectedKey={opsubItem ? opsubItem.id : null}
                onChange={handleChangeItem}
                onPendingValueChanged={handlePendingValueChanged}
                text={text}
            />

        </div>
    );
}

export default SelectOpsubComboBox;
